<template>
    <BreadCrumb PageTitle="Ajouter un régime Douanier" />
    <AddModalRegime />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import AddModalRegime from "@/components/RegimeDouanier/AddModalRegime.vue";

export default defineComponent({
    name: "AddRegimePage",
    components: {
        BreadCrumb,
        AddModalRegime,
    },
});
</script>